// Pure conversion helpers
export function convertValue(category, fromId, toId, value) {
  if (Number.isNaN(value)) return NaN;
  if (category.special && category.id === "temperature") {
    return convertTemperature(fromId, toId, value);
  }
  const from = category.units.find((u) => u.id === fromId);
  const to = category.units.find((u) => u.id === toId);
  if (!from || !to) return NaN;
  const inBase = value * from.factor;
  return inBase / to.factor;
}

function convertTemperature(from, to, v) {
  let c;
  if (from === "celsius") c = v;
  else if (from === "fahrenheit") c = (v - 32) * (5 / 9);
  else c = v - 273.15; // kelvin
  if (to === "celsius") return c;
  if (to === "fahrenheit") return c * (9 / 5) + 32;
  return c + 273.15;
}

export function formatNumber(n) {
  if (n === undefined || n === null || Number.isNaN(n)) return "—";
  if (n === 0) return "0";
  const abs = Math.abs(n);
  if (abs >= 1e15 || (abs < 1e-6 && abs > 0)) return n.toExponential(6);
  const rounded = Number(n.toPrecision(8));
  return rounded.toLocaleString("en-US", { maximumFractionDigits: 8 });
}

export function slugToLabel(s) {
  return s.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}
